import { render, staticRenderFns } from "./Ukrposhta.vue?vue&type=template&id=b1ed769a&scoped=true"
import script from "./Ukrposhta.vue?vue&type=script&lang=js"
export * from "./Ukrposhta.vue?vue&type=script&lang=js"
import style0 from "./Ukrposhta.vue?vue&type=style&index=0&id=b1ed769a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ed769a",
  null
  
)

export default component.exports